<template>
  <header class="bg-white border-b border-gray-300 shadow-lg">
    <div class="flex items-center h-16 px-4 mx-auto max-w-screen-xl gap-8 sm:px-6 lg:px-8">
      <a class="block text-cyan-600" href="/">
        <span class="sr-only">Home</span>
        <router-link to="/">
          <!-- <img class="h-8" alt="Vue logo" src="../assets/logo.png"> -->
          <picture>
            <source srcset="image.webp"> 
            <v-img 
            height="150px" 
            width="150px"
            src="../assets/logo.png"
            ></v-img>
          </picture>
        </router-link>
      </a>

      <div class="flex items-center justify-end flex-1 md:justify-between">
        <nav class="hidden md:block" aria-labelledby="header-navigation">
          <h2 class="sr-only" id="header-navigation">Header navigation</h2>

          <ul class="flex items-center text-sm gap-6">
            <li>
              <router-link to="/">Home</router-link>
             
            </li>

            <li>
              <router-link to="/aulas">Ensino SBCP</router-link>
            </li>

          </ul>
        </nav>

        <div class="flex items-center gap-4">
          <div class="sm:gap-4 sm:flex" v-if="!nome">
            <router-link to="/login">
              <a @click="isOpenLogin = true"  href="javascript:void(0);" class="block px-5 py-2.5 text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 transition">
                Login
              </a>
            </router-link>


            <a class="hidden sm:block px-5 py-2.5 whitespace-nowrap text-sm font-medium text-sky-600 bg-gray-100 hover:text-sky-600/75 transition" href="/">
              Cadastrar-se
            </a>
          </div>
          <div class="sm:gap-4 sm:flex sm:items-center sm:justify-center" v-else>

            <div class="flex items-center justify-center w-8 h-8 bg-gray-100 object-cover rounded-lg aspect-square ">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-sky-800">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </div>

            <p class="hidden sm:block px- py-2.5 whitespace-nowrap text-sm font-medium text-sky-600 hover:text-sky-600/75 transition">
              {{ nome }}
            </p>
            
            <a @click="logout()"  href="javascript:void(0);" class="block px-5 py-2.5 text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 transition">
              Sair
            </a>
          </div>

          <button class="block p-2.5 text-gray-600 transition bg-gray-100 md:hidden hover:text-gray-600/75">
            <span class="sr-only">Toggle menu</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </header>

</template>


<script>
  export default {
    name: "Navbar",
    data() {
        return {
            nome: "",
        };
    },
    methods:{
      async getLogin(){
        const user = JSON.parse(localStorage.getItem('authUser'))
        if(user){
          this.nome = user.nomeUsuario
        }
      },
      logout() {
        localStorage.removeItem('authUser');
        window.location.href = "/login";
      }
    },
    mounted(){
      this.getLogin()
    }
  }
</script>

<style scoped>
  nav {
    padding: 30px;
  }

  nav a:hover {
    color: rgb(2 132 199 / 0.75);
  }

  nav a {
    font-size: 0.875rem/* 14px */;
    line-height: 1.25rem/* 20px */;
    color: rgb(2 132 199);
  }

  nav a.router-link-exact-active {
    color:  rgb(0, 61, 91);
    font-weight: 600;
}
</style>
